import { render, staticRenderFns } from "./ReservationUpdateDialog.vue?vue&type=template&id=00536a9d&scoped=true"
import script from "./ReservationUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ReservationUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00536a9d",
  null
  
)

export default component.exports